import DashboardDay from "./DashboardDay";

// Clase del objeto DashboardIncidence.
class DashboardIncidence {
    // Constructor del objeto DashboardIncidence.
    constructor(props) {
        this.type = "DdI";
        const properties = [
            "analysis", "benefit", "collect", "cover", "coveractivity", "crop", "defense", "fertilize", "guest", "infection",
            "irrigation", "note", "phytosanitary", "plan", "plant", "recipe", "sale", "seed", "shepherd", "state", "work", "harvest"
        ];
        
        properties.forEach(prop => {
            this[prop] = props[prop] ? props[prop].map(item => new DashboardDay(item)) : [];
        });
    }

    // Método genérico para obtener la cantidad total de una propiedad.
    getTotalAmount = (prop) => {
        return this[prop].reduce((total, item) => total + item.value, 0);
    };

    // Métodos individuales para cada propiedad.
    infoAnalysisAmount = () => this.getTotalAmount("analysis");  
    infoBenefitAmount = () => this.getTotalAmount("benefit");   
    infoCollectAmount = () => this.getTotalAmount("collect");
    infoCoverAmount = () => this.getTotalAmount("cover");
    infoCoverActivityAmount = () => this.getTotalAmount("coveractivity");
    infoCropAmount = () => this.getTotalAmount("crop");   
    infoDefenseAmount = () => this.getTotalAmount("defense");
    infoFertilizeAmount = () => this.getTotalAmount("fertilize");
    infoGuestAmount = () => this.getTotalAmount("guest");
    infoInfectionAmount = () => this.getTotalAmount("infection");
    infoIrrigationAmount = () => this.getTotalAmount("irrigation");
    infoNoteAmount = () => this.getTotalAmount("note");
    infoPhytosanitaryAmount = () => this.getTotalAmount("phytosanitary");
    infoPlanAmount = () => this.getTotalAmount("plan");
    infoPlantAmount = () => this.getTotalAmount("plant");
    infoRecipeAmount = () => this.getTotalAmount("recipe");
    infoSaleAmount = () => this.getTotalAmount("sale");
    infoSeedAmount = () => this.getTotalAmount("seed");
    infoShepherdAmount = () => this.getTotalAmount("shepherd");
    infoStateAmount = () => this.getTotalAmount("state");
    infoWorkAmount = () => this.getTotalAmount("work");
    infoHarvestAmount = () => this.getTotalAmount("harvest");   
}

export default DashboardIncidence;